export default __webpack_public_path__ + "static/media/contractVersionPreview.44961514.svg";